import { request, download } from './request'

//登录
export const LoginApi = params => request.post('/a_admin/account/login', params);

/*-------------*
 * 工作台 *
 *-------------*/
export const Workbench_GetList = params => request.get('/a_admin/workbench/home/list', {params});

//文件上传接口
export const FileUpload = params => request.post('/a_admin/system/files/upload', params, {timeout: 600000});
//文件下载接口
export const FileDownload = params => download.get('/api/download', {params});
//文件下载接口
export const FileDownloadNew = params => download.get('/a_admin/system/files/download', {params}, {timeout: 180000});

//消息
export const Message_Get = params => request.get('/api/messages/myMessages', { params });
export const Message_GetLatest = params => request.get('/api/messages/latestMessages', { params });
export const Message_Read = params => request.post('/api/messages/read', params);
export const Message_ReadAll = params => request.post('/api/messages/allRead', params);

//后台用户
export const GetSalesman = params => request.get('/a_admin/system/staff/salesman', {params});
export const GetAccountant = params => request.get('/a_admin/system/staff/accountant', {params});

/*-------------*
 *财务审核*
 *-------------*/
 /*待审核*/
export const Finance_Review_GetTabs = params => request.get('/api/finances/tab/review', {params});
//商标注册
export const Finance_Review_Trademark_GetList = params => request.get('/api/finances/trademarks/review_list', {params});
export const Finance_Review_Trademark_GetCredential = params => request.get('/api/finances/trademarks/view_credentials_file', {params});
export const Finance_Review_Trademark_Confirm = params => request.post('/api/finances/trademarks/confirmation', params);
export const Finance_Review_Trademark_Rejected = params => request.post('/api/finances/trademarks/rejected', params);
//商标异常处理
export const Finance_Review_TrademarkRegistration_GetList = params => request.get('/api/finances/trademark_exceptions/review_list', {params});
export const Finance_Review_TrademarkRegistration_GetCredential = params => request.get('/api/finances/trademark_exceptions/view_credentials_file', {params});
export const Finance_Review_TrademarkRegistration_Confirm = params => request.post('/api/finances/trademark_exceptions/confirmation', params);
export const Finance_Review_TrademarkRegistration_Rejected = params => request.post('/api/finances/trademark_exceptions/rejected', params);
//使用证据
export const Finance_Review_Evidence_GetList = params => request.get('/api/finances/evidence/review_list', {params});
export const Finance_Review_Evidence_Confirm = params => request.post('/api/finances/evidence/confirmation', params);
export const Finance_Review_Evidence_Rejected = params => request.post('/api/finances/evidence/rejected', params);
//税务订单
export const Finance_Review_Tax_GetList = params => request.get('/api/finances/tax/review_list', {params});
export const Finance_Review_Tax_Confirm = params => request.post('/api/finances/tax/confirmation', params);
export const Finance_Review_Tax_Rejected = params => request.post('/api/finances/tax/rejected', params);
//欧盟B2B
export const Finance_Review_EUB2B_GetList = params => request.get('/api/finances/eub2b/review_list', {params});
export const Finance_Review_EUB2B_ViewPay = params => request.get('/api/tax/period/eub2b/view_pay', {params});
export const Finance_Review_EUB2B_Confirm = params => request.post('/api/finances/eub2b/confirmation', params);
export const Finance_Review_EUB2B_Rejected = params => request.post('/api/finances/eub2b/rejected', params);
//产品合规
export const Finance_Review_Compliance_GetList = params => request.get('/api/finances/comply/review_list', {params});
export const Finance_Review_Compliance_Confirm = params => request.post('/api/finances/comply/confirmation', params);
export const Finance_Review_Compliance_Rejected = params => request.post('/api/finances/comply/rejected', params);
//业务下单
export const Finance_Review_Order_GetList = params => request.get('/api/finances/agent/review_list', {params});
export const Finance_Review_Order_Confirm = params => request.post('/api/finances/agent/confirmation', params);
export const Finance_Review_Order_Rejected = params => request.post('/api/finances/agent/rejected', params);
export const Order_Manage_DownOrderFile = params => download.get('/api/agent/orders/download_order_file', {params});

 /*已审核*/
export const Finance_Approved_GetTabs = params => request.get('/api/finances/tab/approved', {params});
//商标注册
export const Finance_Approved_Trademark_GetList = params => request.get('/api/finances/trademarks/approved_list', {params});
//商标异常处理
export const Finance_Approved_TrademarkRegistration_GetList = params => request.get('/api/finances/trademark_exceptions/approved_list', {params});
//使用证据
export const Finance_Approved_Evidence_GetList = params => request.get('/api/finances/evidence/approved_list', {params});
//税务订单
export const Finance_Approved_Tax_GetList = params => request.get('/api/finances/tax/approved_list', {params});
//欧盟B2B
export const Finance_Approved_EUB2B_GetList = params => request.get('/api/finances/eub2b/approved_list', {params});
//产品合规
export const Finance_Approved_Compliance_GetList = params => request.get('/api/finances/comply/approved_list', {params});
//业务下单
export const Finance_Approved_Order_GetList = params => request.get('/api/finances/agent/approved_list', {params});

/*-------------*
 *订单管理*
 *-------------*/
//账单管理
export const Order_Bill_GetTab = params => request.get('/a_admin/orders/bill/tabs', {params});
export const Order_Bill_GetList = params => request.get('/a_admin/orders/bill/list', {params});
export const Order_Bill_GetPendingList = params => request.get('/a_admin/orders/bill/pending', {params});
export const Order_Bill_GetDetail = params => request.get('/a_admin/orders/bill/detail', {params});
export const Order_Bill_Add = params => download.post('/a_admin/orders/bill/add', params);
export const Order_Bill_Receipt = params => request.post('/a_admin/orders/bill/upload_pay', params);
export const Order_Bill_DelBack = params => request.post('/a_admin/orders/bill/del_back', params);

/*账单管理*/
export const Finance_Bill_GetTabs = params => request.get('/a_admin/finances/bill/tabs', {params});
//已开具、已支付、全部
export const Finance_Bill_GetList = params => request.get('/a_admin/finances/bill/list', {params});
export const Finance_Bill_GetDetail = params => request.get('/a_admin/finances/bill/detail', {params});
export const Finance_Bill_ConfirmReceipt = params => request.post('/a_admin/finances/bill/confirm', params);
export const Finance_Bill_Reject = params => request.post('/a_admin/finances/bill/reject', params);
export const Finance_Bill_ReturnToAudit = params => request.post('/a_admin/finances/bill/back_audit', params);
//开票管理
export const Order_Invoice_GetTab = params => request.get('/a_admin/orders/invoice/tabs', {params});
export const Order_Invoice_GetList = params => request.get('/a_admin/orders/invoice/list', {params});
export const Order_Invoice_UpCred = params => request.post('/a_admin/orders/invoice/upload', params);
export const Order_Invoice_HandleExce = params => request.post('/a_admin/orders/invoice/exceptionHandling', params);
export const Order_Invoice_Refund = params => request.post('/a_admin/orders/invoice/refund', params);
export const Customer_InvoiceTitle_GetList = params => request.get('/a_admin/customer/invoiceTitle/list', {params});
//开票管理
export const Finance_Invoice_GetTab = params => request.get('/a_admin/finances/invoice/tabs', {params});
export const Finance_Invoice_GetList = params => request.get('/a_admin/finances/invoice/list', {params});
export const Finance_Invoice_Pass = params => request.post('/a_admin/finances/invoice/pass', params);
export const Finance_Invoice_Reject = params => request.post('/a_admin/finances/invoice/reject', params);

/* 订单管理 */
export const Finance_Order_Standard_Review_GetList = params => request.get('/a_admin/finances/ordersAudit/wait', {params});
export const Finance_Order_Standard_Review_Confirm = params => request.post('/a_admin/finances/ordersAudit/confirm', params);
export const Finance_Order_Standard_Review_Reject = params => request.post('/a_admin/finances/ordersAudit/reject', params);
export const Finance_Order_Standard_Review_MarkRefund_View = params => request.get('/a_admin/finances/ordersAudit/view_refund', {params});
export const Finance_Order_Standard_Review_MarkRefund = params => request.post('/a_admin/finances/ordersAudit/mark_refund', params);
export const Finance_Order_Standard_Review_RejectRefund = params => request.post('/a_admin/finances/ordersAudit/refund_reject', params);
export const Finance_Order_Standard_Approved_GetList = params => request.get('/a_admin/finances/ordersAudit/approved', {params});
export const Finance_Order_Standard_Approved_BackToReview = params => request.post('/a_admin/finances/ordersAudit/back_pay', params);

//获取付款凭证
export const GetCredentialsFile = params => request.post('/api/sbzc/Orders/view_credentials_file', params);
export const GetFinanceTaxOrderByOrderManage = params => request.get('/api/tax/orders/view_pay', {params});
export const GetComplianceEuAgentOrderVoucher = params => request.get('/api/certification/ear/orders/view_credentials_file', {params});

//客户
export const GetCustomer = params => request.get('/api/Customers/list', {params});

//操作日志
export const GetLogRecord = params => request.get('/api/track/list', {params});

/*税务档案*/
//获取税务档案列表
export const GetTaxArchiveList = params => request.get('/api/tax/archives/list', { params });
//获取税务档案详情
export const GetTaxArchiveDetail = params => request.get('/api/tax/archives/view', { params });
//变更资料 -- 补齐资料
export const SaveTaxArchiveAmendInfo = params => request.post('/api/tax/archives/amend_info', params);
//生成绑定链接
export const SetBindLinkTaxArchive = params => request.post('/api/tax/archives/generate_bind_url', params);
export const Tax_Archive_GetAuthUrl = params => request.get('/api/tax/archives/api_auth_url', { params });
export const Tax_Archive_PullHMRCPeriod = params => request.post('/api/tax/archives/pull_hmrc_period', params, { timeout: 300000 });
//德国申报授权 -- 获取申报授权书
export const GetDecAuthFileTaxArchive = params => request.get('/api/tax/archives/declare_auth_file', { params });
//德国申报授权 -- 提交签字
export const SaveSignImgTaxArchive = params => request.post('/api/tax/archives/signature_save', params);
//德国申报授权 -- 确认签字
export const SubmitSignImgTaxArchive = params => request.post('/api/tax/archives/signature_submit', params);
//英国申报授权
export const AuthMarkGBTaxArchive = params => request.post('/api/tax/archives/gb_auth_mark', params);
//德国申报授权 -- 发送给会计师
export const SendAuthToAccTaxArchiveDE = params => request.post('/api/tax/archives/send_auth_accountant', params);
//变更地址
export const Tax_Archive_ChangeAddress_SaveSignature = params => request.post('/api/tax/archives/tax_update_sign_save', params);
export const Tax_Archive_ChangeAddress_GetSignResult = params => request.get('/api/tax/archives/tax_update_sign_result', { params });
export const Tax_Archive_ChangeAddress_GenePrev = params => request.post('/api/tax/archives/generate_view_tax_update_petition', params);
export const Tax_Archive_ChangeAddress_SignConfirm = params => request.post('/api/tax/archives/tax_update_sign_confirm', params);
export const Tax_Archive_ChangeAddress_SendToAccount = params => request.post('/api/tax/archives/tax_update', params);


 /*申报管理 -- 申报跟进*/
 //获取tab
 export const GetTaxDeclareFollowTab = params => request.get('/api/tax/period/obligations/tab_list', { params });
 //获取待上传数据列表
export const GetTaxDeclareFollowList = params => request.get('/api/tax/period/obligations/list', { params });
 //税金计算下一步
export const TaxDeclareFollowCalcNext = params => request.post('/api/tax/period/obligations/calculate', params, {timeout: 300000});
 //快速保存
export const TaxDeclareFollowCalcQuickSave = params => request.post('/api/tax/period/obligations/draft_save', params);
 //获取快速保存
export const GetTaxDeclareFollowCalcQuickSave = params => request.post('/api/tax/period/obligations/draft_save', params);
 //发送税金计算结果
export const SendTaxDeclareFollowCalc = params => request.post('/api/tax/period/obligations/send_result', params);
 //获取历史数据
export const GetTaxDeclareFollowYearHistory = params => request.get('/api/tax/period/obligations/get_year_history', { params });
//历史数据下一步
export const TaxDeclareFollowYearHistoryNext = params => request.post('/api/tax/period/obligations/year_sum_calculate', params, {timeout: 300000});
//按税金计算
export const TaxDeclareFollowCalcByTax = params => request.post('/api/tax/period/obligations/taxes_recalculate', params);
 //标志确认
export const TaxDeclareFollowMarkConfirmed = params => request.post('/api/tax/period/obligations/mark', params);
 //上传税单
export const TaxDeclareFollowUploadBill = params => request.post('/api/tax/period/obligations/upload', params);
 //上传缴税回执
export const TaxDeclareFollowUploadTaxReceipt = params => request.post('/api/tax/period/obligations/upload_receipt', params);
 //批量上传税单
export const BatchUploadTaxDeclareFollowBill = params => request.post('/api/tax/period/obligations/batch_upload', params);
 //批量绑定税单
export const BatchBandTaxDeclareFollowBill = params => request.post('/api/tax/period/obligations/batch_upload_binding', params);
 //批量上传缴税回执
export const BatchUploadTaxDeclareFollowTaxRecipt = params => request.post('/api/tax/period/obligations/batch_upload_receipt', params);
 //批量绑定缴税回执
export const BatchBindTaxDeclareFollowTaxRecipt = params => request.post('/api/tax/period/obligations/batch_upload_receipt_binding', params);
 //ZM report下载并发送
export const DownloadAndSendTaxDeclareFollowZMreport = params => request.post('/api/tax/period/obligations/download_send_zm_report', params);
 //ZM report下载
export const DownloadTaxDeclareFollowZMreport = params => request.post('/api/tax/period/obligations/download_zm_report', params);
 //ZM report发送
export const SendTaxDeclareFollowZMreport = params => request.post('/api/tax/period/obligations/send_zm_report', params);
 //下载计税结果
export const DownloadDeclareFollowCalcResult = params => download.post('/api/tax/period/obligations/download_result', params);
 //作废
export const TaxDeclareFollowMarkInvalid = params => request.post('/api/tax/period/obligations/mark_invalid', params);
 //批量下载税单
export const BatchDownTaxDeclareFollowReceipt = params => download.post('/api/tax/period/obligations/batch_download_receipt', params);
 //申报记录
export const GetTaxDeclareRecordList= params => request.get('/api/tax/obligations_history/list', {params});

//消息
export const GetMessageList = params => request.get('/api/messages/myMessages', {params});
export const GetMessageLatest = params => request.get('/api/messages/latestMessages', {params});
export const SetMessageReadDone = params => request.post('/api/messages/read', params);
export const SetMessageAllReadDone = params => request.post('/api/messages/allRead', params);

/*智能工具*/
//商标检索
export const Tool_Tradmark_Search_GetList = params => request.get('/a_admin/tools/mark/search/list', {params});
export const Tool_Tradmark_Search_GetDesignList = params => request.get('/a_admin/tools/mark/design/list', {params});
export const Tool_Tradmark_Search_SearchData = params => download.post('/a_admin/tools/mark/search/snapshot', params, { timeout: 180000 });
//小项确认工具
export const GetToolItemConfirmList= params => request.get('/a_admin/tools/trademarkProductSelect/list', {params});
export const AddToolItemConfirmLink= params => request.post('/a_admin/tools/trademarkProductSelect/add', params);
export const OpenToolItemConfirmLinkAgain = params => request.post('/a_admin/tools/trademarkProductSelect/update_status', params);
 //热门小项
export const GetToolHotItem = params => request.get('/api/aitools/hot_category_mini/list', {params});
export const AddToolHotItem = params => request.post('/api/aitools/hot_category_mini/add', params);
export const EditToolHotItem = params => request.post('/api/aitools/hot_category_mini/update', params);
export const DelToolHotItem = data => request.delete('/api/aitools/hot_category_mini/delete', {data});
export const BatchAddToolHotItem = params => request.post('/api/aitools/hot_category_mini/batch_add', params, {timeout: 300000});
//商标监测
export const Tool_Monitor_GetList = params => request.get('/a_admin/tools/trademarkListen/list', {params});
export const Tool_Monitor_GetLawyer = params => request.get('/a_admin/tools/trademarkListen/get_lawyer_list', {params});
export const Tool_Monitor_SyncStatus = params => request.get('/a_admin/tools/trademarkListen/syncEvent', { params });
export const Tool_Monitor_Cancel = params => request.post('/a_admin/tools/trademarkListen/cancel', params);
export const Tool_Monitor_Restart = params => request.post('/a_admin/tools/trademarkListen/open', params);
export const Tool_Monitor_ExportData = params => download.post('/a_admin/tools/trademarkListen/export', params);
export const Tool_Monitor_Add = params => request.post('/a_admin/tools/trademarkListen/add', params);
export const Tool_Monitor_BatchAdd = params => request.post('/a_admin/tools/trademarkListen/batchAdd', params);
export const Tool_Monitor_Update = params => request.post('/a_admin/tools/trademarkListen/edit', params);
export const Tool_Monitor_BatchUpdate = params => request.post('/a_admin/tools/trademarkListen/batchEdit', params);

//基础数据
export const GetTrademarkCategory = params => request.get('/api/CategoryTrademark/list', {params});

/*-------------*
 *使用证据*
 *-------------*/
//打标管理
export const Evidence_Engrave_GetTab = params => request.get('/a_admin/evidence/engrave/statistics', {params});
export const Evidence_Engrave_GetList = params => request.get('/a_admin/evidence/engrave/list', {params});
export const Evidence_Engrave_UpMaterial = params => request.put('/a_admin/evidence/engrave/material', params);
export const Evidence_Engrave_ConfirmMark = params => request.put('/a_admin/evidence/engrave/sign', params);
export const Evidence_Engrave_ConfirmPhoto = params => request.put('/a_admin/evidence/engrave/photo', params);
export const Evidence_Engrave_UpPhoto = params => request.put('/a_admin/evidence/engrave/upload', params);
export const Evidence_Engrave_DownData = params => download.get('/a_admin/evidence/engrave/download', {params});
export const Evidence_Engrave_ReviewMaterial = params => request.post('/a_admin/evidence/engrave/inspect', params);
export const Evidence_Engrave_Return = params => request.put('/a_admin/evidence/engrave/retract', params);
export const Evidence_Engrave_Pause = params => request.post('/a_admin/evidence/engrave/cease', params);
export const Setting_TrademarkEvent_GetList = params => request.get('/a_admin/setting/trademarkEvent/list', {params});

/*-------------*
 *订单管理*
 *-------------*/
/* 总订单 */
export const Order_Total_GetBankStatement = params => request.post('/a_admin/orders/orders/view_trading_flow', params);



// WEBPACK FOOTER //
// ./src/api/index.js